<div
  id="tradeStates"
  ngbDropdown
  [autoClose]="'outside'"
  [ngClass]="{ 'disabled-dropdown': disabled }"
>
  <div class="input-group">
    <div class="form-control dropdown-toggle-override" ngbDropdownToggle>
      <span class="icon-container"
        ><i class="bi bi-chevron-down chevron-icon pull-right"></i
      ></span>
      @if (selectedItems.size === 0) {
        <span>Pick one or multiple...</span>
      }
      @if (Items.size > 0) {
        @for (item of selectedItems | keyvalue: preserveMapOrder; track item) {
          <span
            class="badge bg-primary badge-margin"
            contenteditable="false"
            (click)="onBadgeClick($event)"
            >{{ item.key }}
            <i
              class="bi bi-x-lg cursor-select"
              (click)="selectionChange($event, item)"
            ></i
          ></span>
        }
      }
    </div>
  </div>

  <div ngbDropdownMenu>
    <div class="form-check mx-3">
      <label
        for="selectAllItems-{{ selectAllItemsUniqueId }}"
        class="form-check-label cursor-select"
        >{{ selectAllItems ? 'De-select' : 'Select' }} All</label
      >
      <input
        id="selectAllItems-{{ selectAllItemsUniqueId }}"
        type="checkbox"
        class="form-check-input cursor-select"
        [checked]="selectAllItems"
        (change)="selectAll()"
      />
    </div>
    <hr class="m-0 mb-1" />
    <ul class="list-unstyled scrollable-dropdown mb-0">
      @for (item of Items | keyvalue: preserveMapOrder; track item) {
        <ng-container class="">
          @if (item) {
            <li class="px-3">
              <div class="form-check">
                <label
                  for="{{ item.key }}"
                  class="form-check-label cursor-select"
                  >{{ item.key }}</label
                >
                <input
                  id="{{ item.key }}"
                  type="checkbox"
                  class="form-check-input cursor-select"
                  [checked]="selectedItems.has(item.key)"
                  (click)="selectionChange($event, item)"
                />
              </div>
            </li>
          }
        </ng-container>
      }
    </ul>
  </div>
</div>
